import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { transactionSettingsService } from '../services'
import type {
	SetTemporaryDisableDto,
	SetTemporaryDisableResponse,
	ClearTemporaryDisableResponse,
	TransactionType,
} from '../../types'

type SetTemporaryDisableOptions = UseMutationOptions<
	SetTemporaryDisableResponse,
	Error,
	{ type: TransactionType; data: SetTemporaryDisableDto }
>

export const useMutationSetTemporaryDisable = (
	options?: SetTemporaryDisableOptions,
) => {
	return useMutation({
		mutationFn: ({
			type,
			data,
		}: {
			type: TransactionType
			data: SetTemporaryDisableDto
		}) => transactionSettingsService.setTemporaryDisable(type, data),
		...options,
	})
}

type ClearTemporaryDisableOptions = UseMutationOptions<
	ClearTemporaryDisableResponse,
	Error,
	{ type: TransactionType }
>

export const useMutationClearTemporaryDisable = (
	options?: ClearTemporaryDisableOptions,
) => {
	return useMutation({
		mutationFn: ({ type }: { type: TransactionType }) =>
			transactionSettingsService.clearTemporaryDisable(type),
		...options,
	})
}
